import { FormattedMessage } from 'react-intl';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { FeeInfoTooltip } from '@sorare/core/src/atoms/tooltip/FeeInfoTooltip';
import { BodyS } from '@sorare/core/src/atoms/typography';
import { usePaymentFeesMayApply } from '@sorare/core/src/hooks/creditCard/usePaymentMethodFeeBasisPoints';

type Props = {
  isSecondary: boolean;
};

export const PaymentFeeDisclaimer = ({ isSecondary }: Props) => {
  const feesMayApply = usePaymentFeesMayApply(isSecondary);

  if (!feesMayApply) {
    return null;
  }

  return (
    <Horizontal gap={0.5}>
      <FeeInfoTooltip
        title={
          <FormattedMessage defaultMessage="Some payment methods incur processing fees. Any applicable fee will be displayed before you confirm your purchase." />
        }
      />
      <BodyS color="var(--c-nd-600)" as="p">
        <FormattedMessage defaultMessage="Payment processing fees may apply depending on your payment method" />
      </BodyS>
    </Horizontal>
  );
};
